import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { WelcomeMessage } from "../../components";
import { MainCard } from "../../components/channel";
import {
  DEFAULT_CONFIGS,
  ERoute,
  FIXED_CHANNEL_KEYS,
  LOCAL_STORAGE_KEYS,
} from "../../constants";
import { useLocalStorage } from "../../hooks";
import useConfigureFiles from "../../hooks/useConfigureFiles";
import { useChannelStore } from "../../stores";
import useUiStore from "../../stores/useUiStore";
import ChannelCarousel from "../ChannelCarousel";

const HomePage = () => {
  const { t } = useTranslation("component");
  const navigate = useNavigate();
  const { data, isLoading, screenSaver, myPlace } = useConfigureFiles();

  const { channels, setChannelList } = useChannelStore();
  const { isMobile } = useUiStore();
  const { storeConfigures, storeScreenSaver, storeMyPlace, storeLocalStorage } =
    useLocalStorage();

  // TEMPORARY FETCHING - WILL BE REMOVE LATER
  useEffect(() => {
    if (data) {
      storeConfigures(data);


      storeLocalStorage(
        LOCAL_STORAGE_KEYS.SCREEN_SAVER_TIMEOUT,
        data.communityConfiguration.screenSaverTimming?.toString() || DEFAULT_CONFIGS.TIMEOUT
      );

      storeLocalStorage(
        LOCAL_STORAGE_KEYS.RADIUS,
        data.communityConfiguration.myPlaceRadius?.toString() || DEFAULT_CONFIGS.RADIUS
      );

      screenSaver && storeScreenSaver(screenSaver);
      myPlace && storeMyPlace(myPlace);
      const channelList =
        data?.communityConfiguration.channels.filter(
          (c) =>
            ![
              FIXED_CHANNEL_KEYS.MY_PLACE,
              FIXED_CHANNEL_KEYS.SCREEN_SAVER,
            ].includes(c.title)
        ) || [];
      setChannelList(channelList);
    }

    //eslint-disable-next-line
  }, [data]);

  const navigateToMyPlace = (): void => {
    navigate("/" + ERoute.MY_PLACE);
  };

  // The session ID will generate if there is not session available at Home Screen
  useEffect(() => {
    const sessionId = localStorage.getItem(LOCAL_STORAGE_KEYS.SESSIONS_ID);
    if (!sessionId) {
      const id = uuid();
      localStorage.setItem(LOCAL_STORAGE_KEYS.SESSIONS_ID, id);
    }
  }, []);

  return (
    <>
      <WelcomeMessage />
      {isMobile && (
        <MainCard
          title={t("home.myPlace")}
          cardImg="/assets/icons/MyPlace.svg"
          actionHandler={navigateToMyPlace}
        />
      )}
      <Grid
        container
        item
        xs={12}
        height="100%"
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        {isLoading ? (
          <Typography>Loading community...</Typography>
        ) : (
          <ChannelCarousel channelList={channels} />
        )}
      </Grid>
    </>
  );
};

export default HomePage;
